export { default } from "./ArticleCard";
